//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Api from '@/utils/api';
export default {
    data() {
        return {
            hotSort: false
        }
    },
    methods: {

    },
    created () {
    },
    watch: {
        $route(to) {
            var pathName = to.name;
            this.hotSort = false;
            var urlName = ['店铺首页', '全部商品', '促销商品', '店铺动态', 'Groupbuy', 'Member'];
        }
    },
    computed: {
        isFooter() {
            return this.$store.state.isFooter;
        },
        cartCountNum() {
            // console.log(this.$store.state.cartCount);
            return this.$store.state.cartCount;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.vue